export const SET_SETTINGS_SECTIONS = 'SET_SETTINGS_SECTIONS';
export const CLEAR_SETTINGS_SECTIONS = 'CLEAR_SETTINGS_SECTIONS';
export const SET_ACTIVE_SECTION_ID = 'SET_ACTIVE_SECTION_ID';
export const SET_SETTINGS_CONTEXT = 'SET_SETTINGS_CONTEXT';

/**
 * Set the visible settings sections for the current settings page.
 * Called by SettingsPage on mount to tell the sidebar what sections to show.
 * @param {Array<{id: string, title: string}>} sections
 */
export function setSettingsSections(sections) {
  return {
    type: SET_SETTINGS_SECTIONS,
    sections,
  };
}

/**
 * Clear settings sections when leaving a settings page.
 */
export function clearSettingsSections() {
  return {
    type: CLEAR_SETTINGS_SECTIONS,
  };
}

/**
 * Set the currently active (scroll-spy) section ID.
 * @param {string} sectionId
 */
export function setActiveSectionId(sectionId) {
  return {
    type: SET_ACTIVE_SECTION_ID,
    sectionId,
  };
}

/**
 * Set the settings context (which entity's settings are being viewed).
 * Used by LeftNav to determine settings mode and build navigation links.
 * @param {{ context: 'customer'|'siteGroup'|'site', basePath: string }|null} settingsContext
 */
export function setSettingsContext(settingsContext) {
  return {
    type: SET_SETTINGS_CONTEXT,
    settingsContext,
  };
}
